import CognitoUserListPerPage from './abstract/CognitoUserListPerPage'
import Config from '../../../Config'

class CompanyList extends CognitoUserListPerPage {
  constructor (props) {
    super(props)
    this.state = {
      isLoaded: false,
      userList: [],
      userCount: 0,
      searchName: '',
      searchPrefectures: '',
      searchBranch: '',
      searchMember: true,
      searchNonMember: true,
      searchUnapproved: true,
      searchDateStart: '',
      searchDateEnd: '',
      currentPage: 1,
      itemsPerPage: 10,
      totalPages: 1,
    }
    this.apiUrl = Config.adminApiUrl.userManagement
    this.userRoleName = '企業'
    this.userRoleUrl = 'company'
    this.userRole = 'companyAdmin'
  }
}

export default CompanyList



// WEBPACK FOOTER //
// ./src/admin/pages/secure/CompanyList.js